export const indexWorkersQuery = `
query index_workers (
    $limit: Int!,
    $offset: Int!,
    $order_by: [String],
    $job_position_id: String,
    $age_from: Int,
    $age_to: Int,
    $transportation_options: [String],
    $max_restaurant_distance: String,
    $experience: [String],
    $domain_interest: [String],
    $occupations: [String],
    $research_status_key: [String],
    $not_in_other_shortlists: Boolean,
    $sex: [String],
    $languages: [String],
    $skills: [String],
    $job_type: [String],
    $association_status: String,
    $job_application_status: String,
    $displacement_availability: [String],
    $search_vector: String,
    $is_contacted: Boolean,
    $granularity: String,
    $similarity_radius: Int,
    $limit_similar_job_positions: Int,
    $application_date_threshold: DateTime,
    $similar_job_positions_filter: String,
    $exclude_same_employer_similar_job_position: Boolean,
    $semantic_search: String,
    $address_lat: Float,
    $address_lon: Float,
    $displacement_preferences: [String],
  ) {
    index_workers (
      limit: $limit,
      offset: $offset,
      order_by: $order_by,
      job_position_id: $job_position_id,
      age_from: $age_from,
      age_to: $age_to,
      transportation_options: $transportation_options,
      max_restaurant_distance: $max_restaurant_distance,
      experience: $experience,
      domain_interest: $domain_interest,
      occupations: $occupations,
      research_status_key: $research_status_key,
      not_in_other_shortlists: $not_in_other_shortlists,
      sex: $sex,
      languages: $languages,
      skills: $skills,
      job_type: $job_type,
      association_status: $association_status,
      job_application_status: $job_application_status,
      displacement_availability: $displacement_availability,
      search_vector: $search_vector,
      is_contacted: $is_contacted,
      granularity: $granularity,
      similarity_radius: $similarity_radius,
      limit_similar_job_positions: $limit_similar_job_positions,
      application_date_threshold: $application_date_threshold,
      similar_job_positions_filter: $similar_job_positions_filter,
      exclude_same_employer_similar_job_position: $exclude_same_employer_similar_job_position,
      semantic_search: $semantic_search,
      address_lat: $address_lat,
      address_lon: $address_lon,
      displacement_preferences: $displacement_preferences,
    ) {
      data {
        active,
        distance,
        job_application {
          id,
          job_position_id,
          status_key,
          is_contacted,
          is_contacted_at,
          is_contacted_by,
          is_contacted_by_rw_member {
            user_id
            name
            surname
            roles {
              id
              key
            }
          }
          source,
          ambassador_code,
          status {
            sentiment,
            label
          },
          last_bench_status_change_timestamp
          conversation_steps {
            id
            closed_at
            status
            owner {
              user_id
              roles {
                id
                key
              }
            }
            category_var {
              id
              label
              key
            }
          }
          klaaryo_conversation {
            klaaryo_campaign_id
            klaaryo_thread_id
            klaaryo_conversation_id
            conversation_status
          },
          evaluation {
            evaluation_analysis
            score
            alerts {
              relocation
              instability
              overqualified
              salary_mismatch
              availability_risk
              motivation_unclear
              misaligned_background
              preassessment_missing
            }
            highlights,
            suggested_interview_questions,
            inserted_at,
            updated_at,
          },
          complaint {
            id,
            message,
            inserted_at,
            updated_at
          },
          discarded_at,
          discarded_by,
          discarded_reason_var {
            id
            key
            label
          },
          discarded_reason,
          discarded_other_reason,
          custom_discard_motivation,
          added_to_shortlist_by,
          added_to_shortlist_at,
        },
        worker {
          user_id,
          user {
              last_login,
              email,
              phone_number,
              name,
              surname
          },
          birthdate,
          assets {
              type,
              url
          },
          research_info {
              foreground,
              occupations {
                  label_it {
                      label
                  }
              },
              domain_interest_var {
                  label
              }
          },
          notes {
              id
          },
          worker_shortlist_notes {
              worker_id,
              shortlist_id
          },
          name,
          surname,
          cv,
          transportation_options {
              transportation_var {
                  id,
                  key,
                  label,
              }
          },
          experience_var {
              label
          },
          research_status_last_updated,
          research_status {
              key,
              id,
              label,
          },
          sex_var {
              label
          },
          locality,
          address,
          presentation,
          motivation_var {
              label
          },
          displacement_availability_var {
              label
          },
          job_type_var {
              label
          },
          job_types {
            job_type_var {
              label
            }
          },
          shifts {
            shift_var {
              label
            }
          },
          past_experiences {
              occupation {
                  label_it {
                      label
                  }
              },
              from_date,
              to_date,
              restaurant_name,
              restaurant_type_var {
                  label
              },
              city,
              description,
              skills {
                  id,
                  label_it {
                      label
                  }
              }
              references {
                id,
                worker_past_experience_id,
                referent_name,
                referent_surname,
                message,
                workplace_relationship,
                visible_to_employers,
                made_visible_to_employer_at,
                ex_employers_email,
                inserted_at,
                updated_at
              },
              inconsistencies {
                id,
                worker_past_experience_id,
                message,
                inserted_at,
                updated_at
              }
          }
          worker_reports {
            id
          }
        }
      },
      hits
    }
  }
`;
